import config from 'Config';

function getStripeKey() {
  return config.stripeKey;
}

export default getStripeKey;
